/* KIDSpo 一覧(collection): 絞り込みボトムシート / 並び替え / もっと見る */
(function () {
  'use strict';

  var root = document.querySelector('[data-kidspo-collection]');
  if (!root) return;

  var baseUrl = root.getAttribute('data-base-url') || window.location.pathname;
  var currentSort = root.getAttribute('data-sort') || '';

  /* ---------------- 並び替え ---------------- */
  var sortSelect = root.querySelector('[data-kidspo-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------- もっと見る（追加読込） ---------------- */
  var grid = root.querySelector('[data-kidspo-grid]');
  var moreBtn = root.querySelector('[data-kidspo-loadmore]');

  function loadMore() {
    if (!moreBtn || !grid) return;
    var url = moreBtn.getAttribute('data-url');
    if (!url || moreBtn.classList.contains('is-loading')) return;
    var label = moreBtn.querySelector('[data-kidspo-loadmore-label]');
    var prevText = label ? label.textContent : '';
    moreBtn.classList.add('is-loading');
    if (label) label.textContent = '読み込み中…';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-kidspo-grid]');
        var newBtn = doc.querySelector('[data-kidspo-loadmore]');
        if (newGrid) {
          var cells = newGrid.querySelectorAll('.kidspo-grid__cell');
          cells.forEach(function (cell, i) {
            cell.classList.add('kidspo-grid__cell--in');
            cell.style.animationDelay = (i * 35) + 'ms';
            grid.appendChild(cell);
          });
        }
        if (newBtn) {
          moreBtn.setAttribute('data-url', newBtn.getAttribute('data-url'));
          moreBtn.classList.remove('is-loading');
          if (label) label.textContent = prevText;
        } else {
          var wrap = moreBtn.closest('.kidspo-collection__more');
          if (wrap) wrap.remove();
        }
      })
      .catch(function () {
        moreBtn.classList.remove('is-loading');
        if (label) label.textContent = 'もう一度お試しください';
      });
  }
  if (moreBtn) moreBtn.addEventListener('click', loadMore);

  /* ---------------- 絞り込みボトムシート ---------------- */
  var sheet = root.querySelector('[data-kidspo-sheet]');
  if (!sheet) return;

  var openers = root.querySelectorAll('[data-kidspo-sheet-open]');
  var closers = sheet.querySelectorAll('[data-kidspo-sheet-close]');
  var panel = sheet.querySelector('.kidspo-sheet__panel');
  var form = sheet.querySelector('[data-kidspo-sheet-form]');
  var applyBtn = sheet.querySelector('[data-kidspo-sheet-apply]');
  var applyLabel = sheet.querySelector('[data-kidspo-apply-label]');
  var resetBtn = sheet.querySelector('[data-kidspo-sheet-reset]');
  var grip = sheet.querySelector('[data-kidspo-sheet-grip]');
  var lastFocus = null;
  var closeTimer;

  function openSheet() {
    lastFocus = document.activeElement;
    clearTimeout(closeTimer);
    sheet.hidden = false;
    document.body.classList.add('kidspo-sheet-lock');
    // 次フレームでクラス付与＝トランジション発火
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    });
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    var first = sheet.querySelector('input:not([disabled]), button');
    if (first) { try { first.focus(); } catch (e) {} }
    updateCount();
  }
  function closeSheet() {
    sheet.classList.remove('is-open');
    document.body.classList.remove('kidspo-sheet-lock');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    closeTimer = setTimeout(function () { sheet.hidden = true; }, 260);
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }

  openers.forEach(function (o) { o.addEventListener('click', openSheet); });
  closers.forEach(function (c) { c.addEventListener('click', closeSheet); });

  /* URL を現在の選択から組み立て */
  function buildUrl() {
    var url = new URL(baseUrl, window.location.origin);
    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (form) {
      form.querySelectorAll('[data-kidspo-facet-input]').forEach(function (input) {
        if (input.type === 'checkbox') {
          if (input.checked && !input.disabled) url.searchParams.append(input.name, input.value);
        } else if (input.value !== '' && input.value != null) {
          url.searchParams.set(input.name, input.value);
        }
      });
    }
    return url;
  }

  /* 件数ライブ更新（候補URLをfetchして data-count を読む） */
  var countTimer, countAbort;
  function updateCount() {
    if (!applyLabel) return;
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      var url = buildUrl();
      if (countAbort) countAbort.abort();
      countAbort = new AbortController();
      if (applyBtn) applyBtn.classList.add('is-loading');
      fetch(url.toString(), { signal: countAbort.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-kidspo-collection]');
          var n = el ? parseInt(el.getAttribute('data-count'), 10) : null;
          if (applyBtn) applyBtn.classList.remove('is-loading');
          if (n === 0) {
            applyLabel.textContent = '該当する商品がありません';
            if (applyBtn) applyBtn.disabled = true;
          } else if (n != null && !isNaN(n)) {
            applyLabel.textContent = n + '件を見る';
            if (applyBtn) applyBtn.disabled = false;
          }
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (applyBtn) applyBtn.classList.remove('is-loading');
        });
    }, 320);
  }

  if (form) {
    form.addEventListener('change', updateCount);
    form.addEventListener('input', function (e) {
      if (e.target && e.target.type === 'number') updateCount();
    });
  }
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      if (applyBtn.disabled) return;
      window.location.href = buildUrl().toString();
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (!form) return;
      form.querySelectorAll('[data-kidspo-facet-input]').forEach(function (input) {
        if (input.type === 'checkbox') input.checked = false;
        else input.value = '';
      });
      updateCount();
    });
  }

  /* ESC + focus trap */
  document.addEventListener('keydown', function (e) {
    if (sheet.hidden) return;
    if (e.key === 'Escape') { closeSheet(); return; }
    if (e.key === 'Tab') {
      var f = sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* グラブハンドルで下スワイプ→閉じる（モバイル） */
  if (grip && panel) {
    var startY = 0, dy = 0, dragging = false;
    grip.addEventListener('touchstart', function (e) {
      dragging = true; startY = e.touches[0].clientY; dy = 0;
      sheet.classList.add('is-dragging');
    }, { passive: true });
    grip.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dy = e.touches[0].clientY - startY;
      if (dy < 0) dy = 0;
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    grip.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dy > 90) closeSheet();
    });
  }
})();
